// Config panel for the "check_day_of_week" condition block
import React from 'react';
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material';

const DAYS = [
  { value: 0, label: 'Sunday' },
  { value: 1, label: 'Monday' },
  { value: 2, label: 'Tuesday' },
  { value: 3, label: 'Wednesday' },
  { value: 4, label: 'Thursday' },
  { value: 5, label: 'Friday' },
  { value: 6, label: 'Saturday' },
];

const CheckDayOfWeekConfig = ({ config, onChange, onSummaryChange }) => {
  const selectedDays = config.days || [];

  const handleToggle = (dayValue) => {
    const updated = selectedDays.includes(dayValue)
      ? selectedDays.filter((d) => d !== dayValue)
      : [...selectedDays, dayValue].sort();

    const newConfig = { ...config, days: updated };
    onChange(newConfig);
    const labels = updated.map((d) => DAYS.find((dd) => dd.value === d)?.label?.slice(0, 3)).join(', ');
    onSummaryChange(labels || 'No days selected');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="caption" color="text.secondary">
        Checks if today is one of the selected days.
        Branches TRUE if it matches, FALSE otherwise.
      </Typography>

      <FormGroup>
        {DAYS.map((day) => (
          <FormControlLabel
            key={day.value}
            control={
              <Checkbox
                checked={selectedDays.includes(day.value)}
                onChange={() => handleToggle(day.value)}
                size="small"
              />
            }
            label={day.label}
          />
        ))}
      </FormGroup>
    </Box>
  );
};

export default CheckDayOfWeekConfig;
